import { start } from '@/api/exam/examRecord'
import {setStore, getStore} from '@/utils/store'
import { submit } from '@/api/exam/answer'
import { enterFullScreen} from '@/utils/common'
import { unreadReadCount } from '@/api/competition'


const exam = {
  state: {
    exam: getStore({
      name: 'exam'
    }) || {},
    examRecord: getStore({
      name: 'examRecord'
    }) || {},
    subject: getStore({
      name: 'subject'
    }) || {},
    incorrectRecord: getStore({
      name: 'incorrectRecord'
    }) || {},
    cards: getStore({
      name: 'cards'
    }) || {},
    unreadCount:0 ,// 未读消息
    isFullScreen: false //是否全屏
  },
  actions: {
    // 设置题目信息
    SetSubjectInfo ({ commit, state }, subject) {
      commit('SET_SUBJECT', subject)
    },
    // 开始考试
    // StartExam ({ commit, state }, examRecord) {
    //   return new Promise((resolve, reject) => {
    //     start(examRecord).then(response => {
    //       console.log(response.data.data,1111)
    //       commit('SET_EXAM', response.data.data.examination)
    //       commit('SET_EXAM_RECORD', response.data.data.examRecord)
    //       commit('SET_SUBJECT', response.data.data.subjectDto)
    //       commit('SET_CARDS', response.data.data.cards)
    //       resolve(response)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    StartExam ({ commit, state }, examId) {
      return new Promise((resolve, reject) => {
        start(examId).then(response => {
          commit('SET_EXAM', response.data.data)
          // commit('SET_EXAM_RECORD', response.data.data.examRecord)
          // commit('SET_SUBJECT', response.data.data.subjectDto)
          // commit('SET_CARDS', response.data.data.cards)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    
    // 提交考试
    SubmitExam ({ commit, state }, exam) {
      return new Promise((resolve, reject) => {
        submit(exam).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 当前错题记录
    SetIncorrectRecord ({ commit, state }, incorrectRecord) {
      commit('SET_INCORRECT_RECORD', incorrectRecord)
    },
    ClearExam ({ commit }) {
      commit('SET_EXAM', undefined)
      commit('SET_SUBJECT', undefined)
    },
    // 切换到全屏模式考试
    enterFullScreen({commit,state},status){
      commit('SET_EXAM_FULLSCREEN',status)
      if(status){
        enterFullScreen(this)
      }
    },
    // 获取当前未读消息 并更新
    getUnreadCount ({commit,state,rootState }) {
      if (rootState.user.userInfo && rootState.user.userInfo.userId !== undefined)
      {
        unreadReadCount().then(res => {
          const unreadCount = res && res > 99 ? '99+' : res || 0
          commit('SET_UNREAD_COUNT', unreadCount)
        }).catch(() => {
          commit('SET_UNREAD_COUNT', 0)
        })
      }
    }
  },
  mutations: {
    SET_EXAM: (state, exam) => {
      state.exam = exam
      setStore({
        name: 'exam',
        content: state.exam
      })
    },
    SET_EXAM_RECORD: (state, examRecord) => {
      state.examRecord = examRecord
      setStore({
        name: 'examRecord',
        content: state.examRecord
      })
    },
    SET_SUBJECT: (state, subject) => {
      state.subject = subject
      setStore({
        name: 'subject',
        content: state.subject
      })
    },
    SET_INCORRECT_RECORD: (state, incorrectRecord) => {
      state.incorrectRecord = incorrectRecord
      setStore({
        name: 'incorrectRecord',
        content: state.incorrectRecord
      })
    },
    SET_CARDS: (state, cards) => {
      state.cards = cards
      setStore({
        name: 'cards',
        content: state.cards
      })
    },
    SET_UNREAD_COUNT: (state,count) => {
      state.unreadCount = count 
    },
    SET_EXAM_FULLSCREEN:(state,status)=>{
      state.isFullScreen = status
    }
  }
}

export default exam



// WEBPACK FOOTER //
// ./src/store/modules/exam.js